(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["quantity-selector"] && !Shopify.designMode) return;
  try {
    if (!window.__qtyDropdownInit_v5) {
  window.__qtyDropdownInit_v5 = true;

  function updateCartBubbleCount(count) {
    const bubbles = document.querySelectorAll('.cart-bubble');
    bubbles.forEach((bubble) => {
      const countEl = bubble.querySelector('.cart-bubble__text-count');
      const srEl = bubble.querySelector('.visually-hidden');
      if (countEl) countEl.textContent = String(count);
      if (srEl) srEl.textContent = `Artikel im Warenkorb insgesamt: ${count}`;
      if (count > 0) {
        bubble.style.removeProperty('display');
        bubble.removeAttribute('hidden');
        bubble.setAttribute('aria-hidden', 'false');
      } else {
        bubble.setAttribute('aria-hidden', 'true');
        bubble.style.display = 'none';
      }
    });
  }

  function getNearestSectionId(fromEl) {
    const sec = fromEl.closest('[data-section-id]');
    return sec && sec.dataset.sectionId ? sec.dataset.sectionId : null;
  }

  async function fetchSection(id) {
    const url = new URL(window.location.href);
    url.searchParams.set('sections', id);
    const res = await fetch(url.toString(), { headers: { 'Accept': 'application/json' } });
    if (res.ok) {
      try {
        const json = await res.json();
        if (json && typeof json === 'object' && json[id]) return json[id];
      } catch(e) {}
    }
    const u = new URL(window.location.href);
    u.searchParams.set('section_id', id);
    const r = await fetch(u.toString(), { headers: { 'Accept': 'text/html' } });
    return r.ok ? await r.text() : null;
  }

  async function refreshCartUI(anchorEl) {
    const secId = getNearestSectionId(anchorEl);
    if (secId) {
      const html = await fetchSection(secId);
      if (html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const incomingSection =
          doc.querySelector(`[data-section-id="${secId}"]`) || doc.getElementById(secId);
        if (incomingSection) {
          const currentSection =
            document.querySelector(`[data-section-id="${secId}"]`) || document.getElementById(secId);
          if (currentSection) {
            const incomingItems = incomingSection.querySelector('.cart-items-component');
            const currentItems = currentSection.querySelector('.cart-items-component');
            if (incomingItems && currentItems) {
              currentItems.innerHTML = incomingItems.innerHTML;
            } else {
              currentSection.innerHTML = incomingSection.innerHTML;
            }
          }
        }
      }
    }

    const ids = Array.isArray(window.CART_BADGE_SECTION_IDS) ? window.CART_BADGE_SECTION_IDS : [];
    for (const id of [...new Set(ids)]) {
      const html = await fetchSection(id);
      if (!html) continue;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const incoming = doc.querySelector(`[data-section-id="${id}"]`) || doc.getElementById(id);
      let container = document.querySelector(`[data-section-id="${id}"]`) || document.getElementById(id);
      if (incoming && container) container.innerHTML = incoming.innerHTML || html;
    }

    document.dispatchEvent(new CustomEvent('cart:updated'));
  }

  function inferLine(select) {
    const attr = select.getAttribute('data-cart-line');
    if (attr) {
      const n = parseInt(attr, 10);
      if (n > 0) return n;
    }
    const m = select.id && select.id.match(/-(\d+)$/);
    if (m) {
      const idx0 = parseInt(m[1], 10);
      if (!Number.isNaN(idx0)) return idx0 + 1;
    }
    const byDataLine = select.closest('[data-line]');
    if (byDataLine) {
      const n = parseInt(byDataLine.getAttribute('data-line') || '', 10);
      if (n > 0) return n;
    }
    return null;
  }

  async function updateCartLine(line, quantity, selectEl) {
    try {
      if (selectEl) selectEl.disabled = true;
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line, quantity })
      });
      const cart = await res.json();
      updateCartBubbleCount(cart.item_count || 0);
      await refreshCartUI(selectEl);
    } catch (e) {
      if (document.body.classList.contains('template-cart')) {
        window.location.reload();
      }
    } finally {
      if (selectEl) selectEl.disabled = false;
    }
  }

  document.addEventListener('change', (evt) => {
    const select = evt.target.closest('select.variant-option__select');
    if (!select) return;
    const line = inferLine(select);
    if (!line) return;
    const quantity = parseInt(select.value, 10) || 0;
    if (quantity < 0) return;
    updateCartLine(line, quantity, select);
  }, { passive: true });
}
  } catch(e) { console.error(e); }
})();

})();
